import React from "react";
import Lottie from "react-lottie";
import {animationData ,animationDataDark} from "../../assets";
import { useTranslation } from "react-i18next";
import { useStateContext } from "../../context/ContextProvider";

const Loader = () => {
  const { t } = useTranslation();
  const {currentMode}=useStateContext()
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: currentMode ==="Dark" ? animationDataDark : animationData,
    rendererSettings: {
      // preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div className="w-full relative  py-4  flex-col flex items-center justify-center">
      <Lottie options={defaultOptions} width={250} height={250} />

      <h1 className=" mt-2 text-center body-1 text-color-3">
        {t("Loading ...")}
      </h1>
    </div>
  );
};

export default Loader;
